import { BUTTON_TYPES } from '../types'

import css from './BaseButton.module.css'

export function BaseButton({
    TagName,
    children,
    className = '',
    buttonType,
    type = BUTTON_TYPES.NORMAL,
    ...rest
}) {
    return (
        <TagName type={buttonType} className={`${css.button} ${css[type]} ${className}`} {...rest}>
            {children}
        </TagName>
    )
}
